module.exports = __webpack_public_path__ + "img/mail-lock.4fb4b6c4.svg";